import moment from "moment/moment";
import { useState, useEffect, useMemo } from "react";
import { MapMissionTasks } from "../common/mission";
import { MissionEnums, TaskEnums } from "../common/constants";
import { Compare, useEntities } from "@emberly/zenith-client";


const DISPATCH_QUERY = {
  name: "active_or_completed_filter",
  or: [
    {
      path: "state",
      comparer: Compare.EQ,
      value: MissionEnums.State.Created
    },
    {
      and: [
        {
          path: "state",
          comparer: Compare.EQ,
          value: MissionEnums.State.Completed
        },
        {
          path: "lastModified",
          comparer: Compare.GTE,
          value: moment().subtract(48, "hour").toDate() // 24 hour buffer, will be filtered away
        },
      ]
    }
  ]
}


export function useDispatchTasks(employees) {
  const [initialLoad, setInitialLoad] = useState(false);
  const [activeTasks, setActiveTasks] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);
  const [completedTasks24H, setCompletedTasks24H] = useState([]);

  const { entities, loading } = useEntities("Mission", DISPATCH_QUERY);

  useEffect(() => {
    if (!loading) {

      const update = () => {
        const tasks = entities.flatMap(t => MapMissionTasks(t, employees));

        const startOfDay = moment().startOf("day").toDate();
        const last24H = moment().subtract(24, "hour").toDate();

        setActiveTasks(tasks.filter(t => t.state < TaskEnums.State.Completed && t.missionState === MissionEnums.State.Created).reverse())
        setCompletedTasks(tasks.filter(t => t.state >= TaskEnums.State.Completed && moment(t.execution.history?.completed?.created).toDate() >= startOfDay).reverse());
        setCompletedTasks24H(tasks.filter(t => t.state >= TaskEnums.State.Completed && moment(t.execution.history?.completed?.created).toDate() >= last24H).reverse());
        setInitialLoad(true);
      }

      update();

      const timer = setInterval(update, 1000 * 60);

      return () => {
        clearInterval(timer);
      };
    }
  }, [entities, loading, employees]);

  return {
    loading,
    initialLoad,
    activeTasks,
    completedTasks,
    completedTasks24H,
    entities
  };
}